import axios from "../reducers/authinterceptor";
import AuthHeader from "./auth.header";

const getApprovedOrders = async(orderId) => {
    const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/orders?range=[1,1000]&filter=approved", 
        { headers: AuthHeader.authHeader()});
    return {data: response.data, count: response.headers["total-items"]};
  };


const getPO = async(poId) => {
    const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/purchaseorders/" + poId, 
        { headers: AuthHeader.authHeader()});
    return response.data;
  }

const getClosedPurchaseOrders = async() => {
    console.log("Getting Closed Purchase Orders");
    const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/purchaseorders?range=[1,1000]&filter=finalized", 
        { headers: AuthHeader.authHeader()});
        console.log(response);
    return {data: response.data, count: response.headers["total-items"]};
  }

  const submitToSanmar = async(poId) => {
    const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/purchaseorder/submitToSanmar/" + poId, 
        { headers: AuthHeader.authHeader()});
    return response.data;
  }

  const submitPreflightToSanmar = async(poId) => {
    const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/purchaseorder/submitPreflightToSanmar/" + poId, 
        { headers: AuthHeader.authHeader()});
    return response.data;
  }

  const generateXLS = async(poId) => {
    const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/purchaseorder/generateXLS/" + poId, 
        { headers: AuthHeader.authHeader()});
    return response.data;
  }
  const getClosedPurchaseOrder = async(poId) => {
      
      const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/purchaseorderdetails/" + poId, 
          { headers: AuthHeader.authHeader()});
      return response.data;
    }

const PurchaseOrderService = {
    getApprovedOrders,
    getClosedPurchaseOrders,
    getClosedPurchaseOrder,
    getPO,
    submitToSanmar,
    submitPreflightToSanmar,
    generateXLS
};
export default PurchaseOrderService;